export const FORM_TESTID = 'registrationForm';
export const EMAIL_FIELD_TESTID = 'guardian.email';
